<template>
  <div v-if="render" class="main-page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK to List
    </div>

    <div class="bread-box d-flex align-center">
      <span @click="backToSearch" class="span-action">{{ locationLabel }}</span>
      <i class="fas fa-chevron-right fa-fw"></i>
      <span @click="back">Activities</span>
      <i class="fas fa-chevron-right fa-fw"></i>
      <span>{{ view.ProductName }}</span>
    </div>

    <div class="page-title-box">{{ view.ProductName }}</div>

    <div class="main-box d-flex align-start">
      <div class="desc-box">
        <div class="view-img">
          <img :src="view.product_image" />
        </div>

        <div class="view-desc p-overwrite" v-html="view.Description"></div>

        <div class="max-travel-box page-box" v-if="view.MaxTravellerCount">
          <div class="page-label">Max Traveler Count <b>{{ view.MaxTravellerCount }}</b></div>
        </div>

        <div class="voucher-box page-box" v-if="view.VoucherOption_List && view.VoucherOption_List.comments.length">
          <div class="page-label">Voucher Information</div>
          <div class="voucher-desc">{{ view.VoucherOption_List.comments[0].description }}</div>
        </div>

        <div class="departure-box page-box" v-if="view.DepartureTime || view.DeparturePoint || view.DepartureTimeComments">
          <div class="page-label">Departure Information</div>
          <div class="dep-time" v-if="view.DepartureTime">
            <i class="fas fa-clock fa-fw"></i>
            <span>{{ timeFormat(view.DepartureTime) }}</span>
          </div>
          <div class="dep-loc" v-if="view.DeparturePoint">
            <i class="fas fa-map-marker fa-fw"></i>
            {{ view.DeparturePoint }}
          </div>
          <div class="page-desc dep-comment" v-if="view.DepartureTimeComments" v-html="view.DepartureTimeComments"></div>
        </div>
      </div>

      <div class="price-box-wrap">
        <div class="price-box page-box">
          <div class="price-label">Best Price From</div>
          <div class="price-value">
            <!-- {{ currencySymbol[view.Price.Currency] }} -->
            ${{ discount(view.Price, 35).discounted }}
            <!-- ${{ (view.Price.TotalDisplayFare / currency.list[view.Price.Currency]).toFixed(2) }} -->
          </div>
          <a class="lr-btn" @click="bookNow">Book now</a>
        </div>
        <div class="cxl-box page-box" v-if="view.Cancellation_available">
          <div class="page-label">Cancellation Policy</div>
          <div class="cxl-desc">{{ view.Cancellation_Policy }}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import currencySymbol from '@/data/currency.js'
import moment from 'moment-timezone'

export default {
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol
    }
  },
  computed: {
    things () { return this.$store.state.things },
    locationLabel () {
      if (!this.things.location.selected) return ''
      return `${this.things.location.selected.destinationName}, ${this.things.location.selected.countryName}`
    },
    view () { return this.things.view },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    backToSearch () {
      this.$router.push('/search')
      this.$store.commit('things/setThingsData', {view: null})
    },
    back () {
      this.$router.push('/things')
      this.$store.commit('things/setThingsData', {view: null})
    },
    timeFormat (x) {
      return moment(x, 'HH:mm').format('hh:mmA')
    },
    bookNow () {
      this.$router.push('/things/review')
    },
    discount (data, x) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      let discount = price * (x / 100)
      return {
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        discounted: (price - discount).toFixed(2)
      }
    }
  },
  mounted () {
    this.render = false
    if (!this.things.view) {
      this.back()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.main-page-box{
  // background: #fafafa;
  // border: 1px solid #ddd;
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #ff9c09;
  letter-spacing: .7px;
  margin-bottom: 20px;
  cursor: pointer;
}

.bread-box{
  font-size: 12px;
  gap: 10px;
  margin-bottom: 20px;

  .span-action{
    cursor: pointer;

    &:hover{
      color: #ff9c09;
    }
  }
}

.page-title-box{
  font-weight: 600;
  font-size: 36px;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 20px;
}

.price-value{
  font-size: 28px;
  font-weight: 600;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 20px;
}

.page-box{
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px 20px;
}
.page-label{
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 10px;
  letter-spacing: .7px;
}
.page-desc{
  color: #455c72;
  line-height: 1.4;
}

.main-box{
  gap: 20px;
}
.desc-box{
  width: 100%;
  background: #fafafa;
  border: 1px solid #ddd;
  padding: 20px;
}
.view-img, .view-desc{
  margin-bottom: 20px;
}
.max-travel-box,
.voucher-box,
.departure-box{
  margin-top: 10px;
}
.dep-time{
  line-height: 1;
  color: #95a5b5;
  i{
    margin-right: 5px;
    font-size: 14px;
  }
  span{
    font-size: 13px;
    letter-spacing: .7px;
  }
}
.dep-loc,
.dep-comment{
  margin-top: 5px;
}
.dep-loc{
  i{
    color: #ff8585;
    margin-right: 5px;
    font-size: 14px;
  }
}

.price-box{
  width: 350px;

  .lr-btn{
    width: 100%;
    display: block;
  }
}
.price-label{
  font-size: 15px;
  color: #888;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 5px;
}

.cxl-box{
  margin-top: 10px;
  width: 350px;
}
.cxl-desc{
  line-height: 1.5;
  font-size: 14px;
  color: #777;
  letter-spacing: .6px;
}

@media only screen and (max-width: 641px) {
  .bread-box{
    display: none;
  }
  .main-box{
    flex-direction: column;
  }
  .price-box-wrap,
  .price-box,
  .cxl-box{
    width: 100%
  }
}
</style>


// WEBPACK FOOTER //
// details.vue?5fa82df1